<template>
  <div class="main-content">
    <div class="page-header">
      <h3 class="page-title">Proveedores</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="/">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">Compras</a>
        </li>
        <li class="breadcrumb-item active">Proveedores</li>
      </ol>
    </div>
    <div class="card">
      <div class="card-header">
        <button
          type="button"
          class="btn btn-theme"
          @click="openModal('save', '')"
        >Nuevo proveedor</button>
      </div>
      <div class="card-body">
        <div class="form-group row">
          <div class="col-md-6">
            <div class="input-group">
              <select v-model="item" class="form-control col-md-4">
                <option value="name">Nombre del proveedor</option>
                <option value="address">Direccion</option>
                <option value="number">Número</option>
                <option value="email">Correo</option>
                <option value="cui">CUI</option>
              </select>
              <input
                v-model="search"
                type="text"
                class="form-control"
                placeholder="Ingrese el campo a buscar"
                @keyup="showProviders(1,search,item, checkboxmanual)"
              >
              <button type="submit" class="btn btn-theme" @click="showProviders(1,search,item, checkboxmanual)">
                <i class="icon-fa icon-fa-search" /> Buscar
              </button>
            </div>
            <!-- Boton activos / inactivos -->
            <br>
            <div class="custom-control custom-checkbox mb-3">
              <input
                id="customControlValidation1"
                v-model="checkboxmanual"
                type="checkbox"
                class="custom-control-input"
                required
                @change="showProviders(1, search, item, checkboxmanual)"
              >
              <label v-if="checkboxmanual === false" class="custom-control-label" for="customControlValidation1">
                Mostrar datos inactivos
              </label>
              <label v-else class="custom-control-label" for="customControlValidation1">
                Mostrar datos activos
              </label>
              <div class="invalid-feedback">Example invalid feedback text</div>
            </div>
          </div>
        </div>
        <!-- Nueva tabla -->
        <table class="table table-responsive table-hover">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Direccion</th>
              <th>Número</th>
              <th>Correo</th>
              <th>CUI</th>
              <th>Genero</th>
              <th>NIT</th>
              <th>Compañía</th>
              <th>Descripción</th>
              <th>Dirección de la compañia</th>
              <th>Crédito</th>
              <th>Días de crédito</th>
              <th>Estado</th>
              <th>Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="provider in arrayProvider" :key="provider.id">
              <td v-text="provider.name"/>
              <td v-text="provider.address"/>
              <td v-text="provider.number"/>
              <td v-text="provider.email"/>
              <td v-text="provider.cui"/>
              <td v-text="`${ (provider.gender == 1) ? 'Masculino' : 'Femenino' }`"/>
              <td v-text="provider.nit"/>
              <td v-text="provider.company"/>
              <td v-text="provider.description"/>
              <td v-text="provider.address2"/>
              <td v-text="mymoney(provider.credit_limit)"/>
              <td v-text="provider.day_limit"/>
              <td>
                <span v-if="provider.state==1" class="btn btn-success btn-sm">Activo</span>
                <span v-else class="btn btn-danger btn-sm">Desactivado</span>
              </td>
              <td>
                <template>
                  <div class="btn-group mr-2"
                       role="group"
                       aria-label="First group">
                    <button
                      v-tooltip.top-center="'Editar'"
                      class="btn btn-theme"
                      @click="openModal('update', provider)"
                    >
                      <i class="icon-fa icon-fa-pencil" />
                    </button>
                    <button
                      v-tooltip.top-center="'Desactivar'"
                      v-if="provider.state==1"
                      :href="`#${provider.name}`"
                      class="btn btn-danger"
                      @click="openModal('desactivate', provider)"
                    >
                      <i class="icon-fa icon-fa-trash" />
                    </button>
                    <button
                      v-tooltip.top-center="'Activar'"
                      v-else
                      :href="`#${provider.name}`"
                      class="btn btn-info"
                      @click="openModal('activate',provider)"
                    >
                      <i class="icon-fa icon-fa-check" />
                    </button>
                  </div>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- Paginación -->
        <div class="card">
          <div class="card-body">
            <ul class="pagination pagination-primary m-b-0">
              <li v-if="pagination.current_page > 1" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page - 1, search, item, checkboxmanual)"><i class="icon-fa icon-fa-angle-left"/></a>
              </li>
              <li v-for="page in pagesNumber" :key="page" :class="[page == isActived ? 'active' : '']" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(page, search, item, checkboxmanual)" v-text="page"/>
              </li>
              <li v-if="pagination.current_page < pagination.last_page" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page + 1, search, item, checkboxmanual)"><i class="icon-fa icon-fa-angle-right"/></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- MODALES -->
      <sweet-modal ref="provider_modal" :title="modalTitle" hide-close-button blocking>
        <sweet-modal-tab id="tab1" title="Datos personales">
          <div class="form-group">
            <label>Nombre del contacto</label>
            <input
              :class="{ 'is-invalid': $v.name.$error }"
              v-model.trim="name"
              class="form-control"
              placeholder="Ingrese el nombre del contacto"
              @keyup.39="$refs.provider_modal.open('tab2')"
              @input="$v.name.$touch()"
            >
            <div v-if="$v.name.$error">
              <span
                v-if="!$v.name.required"
                class="help-block help-block-error"
              >El nombre es requerido</span>
              <span v-if="!$v.name.minLength" class="help-block help-block-error">
                El minimo del caracteres es de
                {{ $v.name.$params.minLength.min }} letras.
              </span>
            </div>
          </div>

          <div class="form-group">
            <label>Direccion</label>
            <textarea
              v-model.trim="address"
              class="form-control"
              placeholder="Ingrese la dirección del proveedor"
              @keyup.39="$refs.provider_modal.open('tab2')"
              @textarea="$v.address.$touch()"
            />
          </div>

          <div class="form-group">
            <label>CUI</label>
            <masked-input
              v-model.trim="cui"
              :mask="[ /\d/,/\d/, /\d/, /\d/, ' ',/\d/, /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/]"
              class="form-control"
              placeholder="Ingrese el número de identificación personal"
              @keyup.39="$refs.provider_modal.open('tab2')"
            />
          </div>

          <div class="form-group">
            <label>Número</label>
            <masked-input
              v-model.trim="number"
              :mask="[ /\d/,/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
              class="form-control"
              placeholder="Ingrese el número de teléfono"
              @keyup.39="$refs.provider_modal.open('tab2')"
            />
          </div>

          <div class="form-group">
            <label>Correo</label>
            <input
              v-model.trim="email"
              :class="{ 'is-invalid': $v.email.$error }"
              type="email"
              class="form-control"
              placeholder="Ingrese el correo electrónico"
              @input="$v.email.$touch()"
            >
            <div v-if="$v.email.$error">
              <span
                v-if="!$v.email.correo"
                class="help-block help-block-error"
              >El correo electrónico es invalido</span>
            </div>
          </div>

          <div class="form-group">
            <label>Genero</label>
            <select v-model.trim="gender" class="form-control">
              <option value="0">Seleccione el genero</option>
              <option value="1">Masculino</option>
              <option value="2">Femenino</option>
            </select>
          </div>
        </sweet-modal-tab>
        <sweet-modal-tab id="tab2" title="Datos profesionales" >
          <div class="form-group">
            <label>NIT</label>
            <input
              ref="nameInput"
              :class="{ 'is-invalid': $v.providerNit.$error }"
              v-model.trim="providerNit"
              class="form-control"
              placeholder="C/F"
              @input="$v.providerNit.$touch()"
            >
            <div v-if="$v.providerNit.$error">
              <span
                v-if="!$v.providerNit.nit"
                class="help-block help-block-error"
              >El número de nit no es válido.</span>
            </div>
          </div>

          <div class="form-group">
            <label>Compañia</label>
            <input
              :class="{ 'is-invalid': $v.company.$error }"
              v-model.trim="company"
              class="form-control"
              placeholder="Ingrese el nombre de la compañia"
              @input="$v.company.$touch()"
            >
            <div v-if="$v.company.$error">
              <span
                v-if="!$v.company.required"
                class="help-block help-block-error"
              >La compañia es requerida</span>
            </div>
          </div>

          <div class="form-group">
            <label>Direccion de la compañia</label>
            <textarea
              v-model.trim="address2"
              class="form-control"
              placeholder="Ingrese la dirección de la compañia"
              @textarea="$v.address2.$touch()"
            />
          </div>

          <div class="form-group">
            <label>Descripción de la compañia</label>
            <input
              v-model.trim="description"
              class="form-control"
              placeholder="Ingrese la descripción de la compañia"
            >
          </div>

          <div class="form-group">
            <label>Crédito</label>
            <masked-input
              v-model.trim="credit_limit"
              :class="{ 'is-invalid': $v.credit_limit.$error }"
              :mask="mask_quetzal"
              :guide="false"
              :keep-char-positions="true"
              :show-mask="true" type="text"
              placeholder="Ingrese el límite de credito"
              class="form-control"
              @keyup.13="saveProvider"
              @input="$v.credit_limit.$touch()" />

            <div v-if="$v.credit_limit.$error">
              <span
                v-if="!$v.credit_limit.required"
                class="help-block help-block-error"
              >El campo es requerido</span>
            </div>
          </div>

          <div class="form-group">
            <label>Días de crédito</label>
            <input
              v-if="converMaskToNumber(credit_limit) > 0.00 && credit_limit"
              :class="{ 'is-invalid': $v.day_limit.$error }"
              v-model.trim="day_limit"
              class="form-control"
              placeholder="Ingrese el límite de días del crédito"
              @keyup.13="saveProvider"
              @input="$v.day_limit.$touch()"
            >
            <input
              v-if="converMaskToNumber(credit_limit) == 0.00 || !credit_limit"
              v-model="day_limit"
              readonly
              disabled
              class="form-control"
              placeholder="Sin días de crédito"
              @input="$v.day_limit.$touch()"
            >
            <div v-if="converMaskToNumber(credit_limit)!=0.00">
              <div v-if="$v.day_limit.$error">
                <span
                  v-if="!$v.day_limit.required"
                  class="help-block help-block-error"
                >El campo es requerido</span>
                <span
                  v-else-if="!$v.day_limit.dayNotSameAscero"
                  class="help-block help-block-error">
                  Los dias de crédito deben ser mayor a cero
                </span>
              </div>
            </div>
          </div>
        </sweet-modal-tab>
        <!-- Inicia modal -->
        <!-- Termina modal -->
        <!-- Botones -->
        <button slot="button" type="button" class="btn btn-danger" @click="closeModal()">Cancelar</button>
        <button
          v-if="tipoAccion == 1"
          slot="button"
          type="button"
          class="btn btn-primary ladda-button"
          data-style="expand-right"
          @click="saveProvider()"
        >Guardar</button>
        <button
          v-if="tipoAccion == 2"
          slot="button"
          type="button"
          class="btn btn-primary ladda-button"
          data-style="expand-right"
          @click="updateProvider()"
        >Actualizar</button>
      </sweet-modal>
      <sweet-modal ref="state_modal" icon="info" hide-close-button blocking>
        {{ modalTitleState }}
        <button
          slot="button"
          type="button"
          class="btn btn-info"
          @click="$refs.state_modal.close()"
        >No</button>
        <button
          v-if="tipoAccion == 3"
          slot="button"
          type="button"
          class="btn btn-danger"
          @click="desactivateProvider()"
        >Si</button>
        <button
          v-if="tipoAccion == 4"
          slot="button"
          type="button"
          class="btn btn-success"
          @click="activateProvider()"
        >Si</button>
      </sweet-modal>
    </div>
  </div>
</template>
<script>
import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
import { required, sameAs, minLength, not } from 'vuelidate/lib/validators'
import {xelacode} from '../../../helpers/xelacode'
import MaskedInput from 'vue-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import ladda from 'ladda'

let nit = (value) => xelacode.nitIsValid(value)
let correo = (value) => xelacode.correo(value)

export default {
  components: {
    SweetModal,
    SweetModalTab,
    'masked-input': MaskedInput
  },
  data () {
    return {
      checkboxmanual: false,
      arrayProvider: [],
      person_id: 0,
      name: '',
      address: '',
      number: '',
      email: '',
      cui: '',
      gender: 0,
      state: 0,
      providerNit: '',
      company: '',
      description: '',
      address2: '',
      credit_limit: '',
      day_limit: '',
      tipoAccion: 1,
      modalTitle: '',
      modalTitleState: '',
      pagination: {
        total: 0,
        current_page: 0,
        per_page: 0,
        last_page: 0,
        from: 0,
        to: 0
      },
      offset: 3,
      item: 'name',
      search: '',
      cero: '0',
      mask_quetzal: createNumberMask({
        prefix: 'Q ',
        suffix: '',
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ',',
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 10, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false
      })
    }
  },
  install (Vue, options) {
    Vue.component('SweetModal', SweetModal)
    Vue.component('SweetModalTab', SweetModalTab)
  },
  validations () {
    if (this.converMaskToNumber(this.credit_limit) > 0.00 && this.credit_limit) {
      return {
        name: {
          required,
          minLength: minLength(4)
        },
        providerNit: {
          nit
        },
        company: {
          required
        },
        credit_limit: {
          required
        },
        day_limit: {
          required,
          dayNotSameAscero: not(sameAs('cero'))
        },
        email: {
          correo
        }
      }
    } else {
      return {
        name: {
          required,
          minLength: minLength(4)
        },
        providerNit: {
          nit
        },
        company: {
          required
        },
        credit_limit: {
          required
        },
        day_limit: {
        },
        email: {
          correo
        }
      }
    }
  },
  computed: {
    isActived: function () {
      return this.pagination.current_page
    },
    pagesNumber: function () {
      if (!this.pagination.to) {
        return []
      }
      var from = this.pagination.current_page - this.offset
      if (from < 1) {
        from = 1
      }
      var to = from + this.offset * 2
      if (to >= this.pagination.last_page) {
        to = this.pagination.last_page
      }
      var pagesArray = []
      while (from <= to) {
        pagesArray.push(from)
        from++
      }
      return pagesArray
    }
  },
  mounted () {
    this.showProviders(1, this.search, this.item, this.checkboxmanual)
  },
  methods: {
    changePage (page, search, item, checkboxmanual) {
      let me = this
      me.pagination.current_page = page
      me.showProviders(page, search, item, checkboxmanual)
    },
    async showProviders (page, search, item, checkboxmanual) {
      let me = this
      // eslint-disable-next-line no-unused-vars
      const response =
      // eslint-disable-next-line no-undef
      await axios
        .get(
          `/api/admin/providers/get?page=${page}&search=${search}&item=${item}&checkboxmanual=${checkboxmanual}`
        )
        .then(function (response) {
          var respuesta = response.data
          me.arrayProvider = respuesta.providers.data
          me.pagination = respuesta.pagination
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // Mascara para el input
    converMaskToNumber (value) {
      var myNumber = ''
      for (var i = 0; i < value.length; i += 1) {
        if (value.charAt(i) === 'Q' || value.charAt(i) === ',' || value.charAt(i) === ' ') {
          continue
        } else {
          myNumber += value.charAt(i)
        }
      }
      return parseFloat(myNumber).toFixed(2)
    },
    // METHOD QUETZALES
    mymoney (value) {
      return xelacode.money(parseFloat(value))
    },
    //
    saveProvider () {
      var l = ladda.create(document.querySelector('.ladda-button'))
      this.$v.$touch()
      let me = this
      if (this.$v.$invalid) {
        // eslint-disable-next-line no-undef
        toastr.error('Revise los campos', 'Error')
      } else {
        l.start()
        // eslint-disable-next-line no-undef
        axios
          .post('/api/admin/providers', {
            name: this.name,
            address: this.address,
            number: this.number,
            email: this.email,
            cui: this.cui,
            gender: this.gender,
            nit: this.providerNit,
            company: this.company,
            credit_limit: this.converMaskToNumber(this.credit_limit),
            day_limit: this.day_limit,
            description: this.description,
            address2: this.address2
          })
          .then(function (response) {
            // eslint-disable-next-line no-undef
            toastr.success(response.data.message, 'Éxito')
            l.stop()
            me.closeModal()
          })
          .catch(function () {
            l.stop()
            // eslint-disable-next-line no-undef
            toastr.error('Problemas en el servidor', 'Error')
          })
      }
    },
    updateProvider () {
      var l = ladda.create(document.querySelector('.ladda-button'))
      this.$v.$touch()
      this.$v.providerNit.$touch()
      let me = this
      if (this.$v.$invalid) {
        // eslint-disable-next-line no-undef
        toastr.error('Revise los campos', 'Error')
      } else {
        l.start()
        // eslint-disable-next-line no-undef
        axios
          .put('/api/admin/providers/update', {
            id: this.person_id,
            name: this.name,
            address: this.address,
            number: this.number,
            email: this.email,
            cui: this.cui,
            gender: this.gender,
            nit: this.providerNit,
            company: this.company,
            description: this.description,
            credit_limit: this.converMaskToNumber(this.credit_limit),
            day_limit: this.day_limit,
            address2: this.address2
          })
          .then(function (response) {
            // eslint-disable-next-line no-undef
            toastr.success(response.data.message, 'Éxito')
            l.stop()
            me.closeModal()
          })
          .catch(function () {
            l.stop()
            // eslint-disable-next-line no-undef
            toastr.error('Problemas en el servidor', 'Error')
          })
      }
    },
    activateProvider () {
      let me = this
      // eslint-disable-next-line no-undef
      axios
        .put('/api/admin/providers/activate', {
          id: this.person_id
        })
        .then(function (response) {
          // eslint-disable-next-line no-undef
          toastr.success('Proveedor activado', 'Éxito')
          me.closeModal()
        })
        .catch(function () {
          // eslint-disable-next-line no-undef
          toastr.error('Problemas en el servidor', 'Error')
        })
    },
    desactivateProvider () {
      let me = this
      // eslint-disable-next-line no-undef
      axios
        .put('/api/admin/providers/desactivate', {
          id: this.person_id
        })
        .then(function (response) {
          // eslint-disable-next-line no-undef
          toastr.success('Proveedor desactivado', 'Éxito')
          me.closeModal()
        })
        .catch(function () {
          // eslint-disable-next-line no-undef
          toastr.error('Problemas en el servidor', 'Error')
        })
    },
    openModal (accion, data = []) {
      let me = this
      this.$v.$reset()
      switch (accion) {
        case 'save': {
          me.$refs.provider_modal.open()
          this.modalTitle = 'Nuevo proveedor'
          this.name = ''
          this.address = ''
          this.number = ''
          this.email = ''
          this.cui = ''
          this.gender = 0
          this.company = ''
          this.description = ''
          this.address2 = ''
          this.tipoAccion = 1
          break
        }
        case 'update': {
          me.$refs.provider_modal.open()
          this.modalTitle = 'Actualizar proveedor'
          this.person_id = data['id']
          this.name = data['name']
          this.address = data['address']
          this.number = data['number']
          this.email = data['email']
          this.cui = data['cui']
          this.gender = data['gender']
          this.gender = data['gender']
          if (data['nit'] === 'C/F') {
            this.providerNit = ''
          } else {
            this.providerNit = data['nit']
          }
          this.credit_limit = this.mymoney(data['credit_limit'])
          if (data['day_limit'] === 0) {
            this.day_limit = ''
          } else {
            this.day_limit = data['day_limit']
          }
          this.company = data['company']
          this.description = data['description']
          this.address2 = data['address2']
          this.tipoAccion = 2
          break
        }
        case 'desactivate': {
          me.$refs.state_modal.open()
          this.modalTitleState = '¿Desea desactivar a este proveedor?'
          this.person_id = data['id']
          this.tipoAccion = 3
          break
        }
        case 'activate': {
          me.$refs.state_modal.open()
          this.modalTitleState = '¿Desea activar a este proveedor?'
          this.person_id = data['id']
          this.tipoAccion = 4
          break
        }
      }
    },
    closeModal () {
      this.showProviders(this.pagination.current_page, this.search, this.item, this.checkboxmanual)
      this.$refs.provider_modal.close()
      this.$refs.state_modal.close()
      document.body.style.overflow = ''
      this.$v.$reset()
      this.person_id = 0
      this.name = ''
      this.address = ''
      this.number = ''
      this.email = ''
      this.cui = ''
      this.gender = 0
      this.company = ''
      this.description = ''
      this.credit_limit = ''
      this.day_limit = ''
      this.address2 = ''
      this.modalTitle = ''
      this.modalTitleState = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/views/admin/persons/Provider.vue